interface ErrorMessageProps {
  error: Error | null
}
export interface CustomError {
  status?: number
  payload?: {
    ok?: boolean
    error?: string
  }
  name?: string
}

export default function ErrorMessage({ error }: ErrorMessageProps) {
  return (
    <span role="alert">
      Error
      {__DEV__ && <pre>{error?.message}</pre>}
    </span>
  )
}
